/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gem_Pack_4_TitleInputs */

const en_gem_pack_4_title = /** @type {(inputs: Gem_Pack_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cart of Crystals`)
};

const ar_gem_pack_4_title = /** @type {(inputs: Gem_Pack_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عربة بلورات`)
};

const de_gem_pack_4_title = /** @type {(inputs: Gem_Pack_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Wagenladung Kristalle`)
};

const es_gem_pack_4_title = /** @type {(inputs: Gem_Pack_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrito de cristales`)
};

const fr_gem_pack_4_title = /** @type {(inputs: Gem_Pack_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un wagon de Gemmes`)
};

const it_gem_pack_4_title = /** @type {(inputs: Gem_Pack_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carriola di Cristalli`)
};

const ja_gem_pack_4_title = /** @type {(inputs: Gem_Pack_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カート一杯の結晶`)
};

const ko_gem_pack_4_title = /** @type {(inputs: Gem_Pack_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크리스탈 한 수레`)
};

const pt_br_gem_pack_4_title = /** @type {(inputs: Gem_Pack_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrinho de cristais`)
};

const ru_gem_pack_4_title = /** @type {(inputs: Gem_Pack_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тележка кристаллов`)
};

const th_gem_pack_4_title = /** @type {(inputs: Gem_Pack_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คริสตัลหนึ่งรถเข็น`)
};

const tr_gem_pack_4_title = /** @type {(inputs: Gem_Pack_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir El Arabası Kristal`)
};

const zh_cn_gem_pack_4_title = /** @type {(inputs: Gem_Pack_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一推车宝石`)
};

const zh_tw_gem_pack_4_title = /** @type {(inputs: Gem_Pack_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一推車寶石`)
};

/**
* | output |
* | --- |
* | "Cart of Crystals" |
*
* @param {Gem_Pack_4_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const gem_pack_4_title = /** @type {((inputs?: Gem_Pack_4_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gem_Pack_4_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gem_pack_4_title(inputs)
	if (locale === "ar") return ar_gem_pack_4_title(inputs)
	if (locale === "de") return de_gem_pack_4_title(inputs)
	if (locale === "es") return es_gem_pack_4_title(inputs)
	if (locale === "fr") return fr_gem_pack_4_title(inputs)
	if (locale === "it") return it_gem_pack_4_title(inputs)
	if (locale === "ja") return ja_gem_pack_4_title(inputs)
	if (locale === "ko") return ko_gem_pack_4_title(inputs)
	if (locale === "pt_br") return pt_br_gem_pack_4_title(inputs)
	if (locale === "ru") return ru_gem_pack_4_title(inputs)
	if (locale === "th") return th_gem_pack_4_title(inputs)
	if (locale === "tr") return tr_gem_pack_4_title(inputs)
	if (locale === "zh_cn") return zh_cn_gem_pack_4_title(inputs)
	return zh_tw_gem_pack_4_title(inputs)
});